import React from 'react';
import { useHistory } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    '& svg': {
      fill: 'var(--color-colorPrimary-main)',
      marginRight: 16,
      fontSize: '1.25rem',
    },

    '& .subscription-icon': {
      width: 24,
      height: 24,
      marginLeft: '-2px',
      '& path': {
        fill: 'var(--color-colorPrimary-main)',
      },
    },
  },
}));

const AppBarMenuItem = ({
  href = '',
  onClick = () => {},
  handleMenuClose = () => {},
  title = '',
  icon = null,
  className = '',
}) => {
  const history = useHistory();
  const classes = useStyles();

  const redirectTo = () => {
    history.push(href);
    handleMenuClose();
  };

  return (
    <MenuItem
      className={`${classes.root} ${className}`}
      onClick={(e) => (href ? redirectTo() : onClick(e))}
    >
      {icon}
      {title}
    </MenuItem>
  );
};

export default AppBarMenuItem;
